export const NAV_BOTTOM_PADDING = 32;
export const NAV_HORIZONTAL_PADDING = 24;
export const NAV_HORIZONTAL_PADDING_SMALL = 14;

export const NAV_TOP_PADDING = 48;
export const NAV_LOGO_HEIGHT = 23;
export const NAV_SEARCHBAR_PADDING_TOP = 24;
export const NAV_SEARCHBAR_PADDING_TOP_SMALL = 16;
